import React, { useMemo, useState, useCallback } from "react";
import { translateText } from "../../../../shared/utils/historyTranslation";

const ALARM_COLORS = [
  "#f43f46",
  "#facc15",
  "#38bdf8",
  "#22c55e",
  "#a78bfa",
  "#fb923c",
  "#ec4899",
  "#14b8a6",
];

function getPointAlarms(point) {
  if (Array.isArray(point.alarms)) return point.alarms;

  if (typeof point.detail === "string") {
    return [...new Set(point.detail.match(/A\d+/g) || [])];
  }

  if (point.count > 0) return ["ALARM"];

  return [];
}

function getAlarmLabelsFromDetail(detail) {
  if (typeof detail !== "string") return {};

  return detail.split("/").reduce((acc, rawPart) => {
    const part = rawPart.trim();
    const match = part.match(/^(A\d+)\s*:\s*(.+)$/);

    if (match) {
      acc[match[1]] = match[2].trim();
    }

    return acc;
  }, {});
}

export default React.memo(function SummaryV3AlarmTrendChart({ points = [], translate }) {
  const t = useCallback((key, fallback) => translateText(translate, key, fallback), [translate]);
  const [zoom, setZoom] = useState(1);

  const handleWheelZoom = useCallback((event) => {
    event.preventDefault();

    setZoom((current) => {
      const direction = event.deltaY > 0 ? -0.15 : 0.15;
      return Math.min(3, Math.max(0.6, current + direction));
    });
  }, []);

  const { visiblePoints, alarmMeta, lastAlarmDetail } = useMemo(() => {
    const enrichedPoints = points.map((point) => ({
      ...point,
      alarmCodes: [...new Set(getPointAlarms(point))],
    }));

    const onlyAlarmPoints = enrichedPoints.filter(
      (point) => point.alarmCodes.length > 0
    );

    const alarmCodes = [
      ...new Set(onlyAlarmPoints.flatMap((point) => point.alarmCodes)),
    ];

    const alarmLabels = onlyAlarmPoints.reduce((acc, point) => {
      return {
        ...acc,
        ...getAlarmLabelsFromDetail(point.detail),
      };
    }, {});

    const nextAlarmMeta = Object.fromEntries(
      alarmCodes.map((code, index) => [
        code,
        {
          color: ALARM_COLORS[index % ALARM_COLORS.length],
          label: alarmLabels[code] || code,
        },
      ])
    );

    const nextVisiblePoints = onlyAlarmPoints;
    const lastAlarm = nextVisiblePoints.at(-1);

    return {
      visiblePoints: nextVisiblePoints,
      alarmMeta: nextAlarmMeta,
      lastAlarmDetail: lastAlarm?.detail || t("summary_v3_no_recorded_alarms", "Sin alarmas registradas"),
    };
  }, [points, t]);

  return (
    <span className="summary-v3__alarmTrend">
      <strong>{t("summary_v3_alarms_over_time", "Alarmas en el tiempo")}</strong>

      <span className="summary-v3__alarmTrendLegend">
        {Object.entries(alarmMeta).map(([code, meta]) => (
          <span key={code}>
            <i style={{ "--alarm-color": meta.color }} />
            {code}: {meta.label}
          </span>
        ))}
      </span>

      <span className="summary-v3__alarmTrendBars" onWheel={handleWheelZoom} style={{ "--alarm-zoom": zoom }}>
        {visiblePoints.length ? (
          visiblePoints.map((point, index) => (
            <span
              key={`${point.key}-${index}`}
              className="summary-v3__alarmTrendBar"
              title={`${point.label} | ${point.detail}`}
            >
              <span className="summary-v3__alarmStack">
                {point.alarmCodes.map((alarmCode) => (
                  <i
                    key={alarmCode}
                    className="summary-v3__alarmSegment"
                    style={{
                      "--alarm-color": alarmMeta[alarmCode]?.color || "#94a3b8",
                    }}
                    title={`${alarmCode}: ${alarmMeta[alarmCode]?.label || alarmCode}`}
                  />
                ))}
              </span>

              <em>{point.shortLabel}</em>
            </span>
          ))
        ) : (
          <span className="summary-v3__alarmTrendEmpty">
            {t("summary_v3_no_alarm_history", "Sin historial de alarmas")}
          </span>
        )}
      </span>
    </span>
  );
});

// import React, { useMemo } from "react";

// export default React.memo(function SummaryV3AlarmTrendChart({ points }) {
//   const { visiblePoints, maxCount, lastAlarmDetail } = useMemo(() => {
//     // const nextVisiblePoints = points.slice(-18);
//     const nextVisiblePoints = points;
//     const nextMaxCount = Math.max(1, ...nextVisiblePoints.map((point) => point.count));
//     const lastAlarm = nextVisiblePoints.filter((point) => point.count).slice(-1)[0];

//     return {
//       visiblePoints: nextVisiblePoints,
//       maxCount: nextMaxCount,
//       lastAlarmDetail: lastAlarm?.detail || "Sin alarmas registradas",
//     };
//   }, [points]);

//   return (
//     <span className="summary-v3__alarmTrend">
//       <strong>Alarmas en el tiempo</strong>
//       <span className="summary-v3__alarmTrendBars">
//         {visiblePoints.length ? (
//           visiblePoints.map((point, index) => (
//             <span
//               key={`${point.key}-${index}`}
//               className={`summary-v3__alarmTrendBar ${point.count ? "has-alarm" : ""}`}
//               style={{ "--alarm-height": `${point.count ? Math.max(18, (point.count / maxCount) * 100) : 7}%` }}
//               title={`${point.label} | ${point.detail}`}
//             >
//               <i />
//               <em>{point.shortLabel}</em>
//             </span>
//           ))
//         ) : (
//           <span className="summary-v3__alarmTrendEmpty">Sin historial de alarmas</span>
//         )}
//       </span>
//       <span className="summary-v3__alarmTrendLast">
//         {lastAlarmDetail}
//       </span>
//     </span>
//   );
// });
